<template>
  <div>
    <div class="col-sm-12 mt-4" v-if="!payment.type">
      <label
        v-if="!editingPaymentConfig"
        v-for="option in userPaymentOptions"
        class="d-flex"
        :class="{
            '': option.selected,
            '': !option.selected,
            'opacity-50': !option.enabled
          }"
      >
        <input
          class="absolute h-4 left-2 top-2 w-4 opacity-50"
          @change="toggleSelected(option)"
          :disabled="!option.enabled"
          :checked="option.selected"
          type="checkbox"
          :value="option.hash"
        >
        <span class="flex-grow-1">
          <span :class="{'': option.selected}">{{ option.gateway.name }}</span>
          <span class="">{{ option.name }}</span>
        </span>
        <font-awesome-icon :icon="['fas', 'pen']"
                           v-tooltip="{content:$t('ct-option-edit'),  class: 'tooltip-custom'}"
                           class="font-awesome-icon float-right text-info mr-3"
                           @click="editPaymentOption(option)"/>
        <font-awesome-icon
          :icon="['far', 'trash-alt']"
          v-tooltip="{content:$t('ct-option-delete'),  class: 'tooltip-custom'}"
          class="font-awesome-icon float-right danger text-danger"
          @click="removePaymentOption(option)"
        />
      </label>
      <button
        class="btn btn-outline-primary"
        @click="toggleNewPaymentOption"
      >
        <svg :class="{'rotate-45': editingPaymentConfig}" width="16" height="16" xmlns="http://www.w3.org/2000/svg"
             viewBox="0 0 491.86 491.86">
          <path fill="#333"
                d="M465.167 211.614H280.245V26.691c0-8.424-11.439-26.69-34.316-26.69s-34.316 18.267-34.316 26.69v184.924H26.69C18.267 211.614 0 223.053 0 245.929s18.267 34.316 26.69 34.316h184.924v184.924c0 8.422 11.438 26.69 34.316 26.69s34.316-18.268 34.316-26.69V280.245H465.17c8.422 0 26.69-11.438 26.69-34.316s-18.27-34.315-26.693-34.315z"></path>
        </svg>
      </button>
      <button class="btn btn-outline-primary"
              v-if="editingPaymentConfig && !payment.slug"
              v-for="gateway in gateways"
              :key="gateway.slug"
              :class="{'active': payment.type === gateway.slug}"
              @click="payment.type = gateway.slug"
      >
        {{ gateway.name }}
      </button>
    </div>
    <conponent
      v-if="editingPaymentConfig && payment.type"
      :is="`${payment.type}-config`"
      :email="info.email"
      :e="e"
      v-model="payment[payment.type]"
      @save="savePayment"
      @cancel="editingPaymentConfig = false"
    />
  </div>
</template>

<script>
import {
  clearCache,
  getSiteInfo,
  removePaymentConfig,
  savePaymentConfig
} from '../../../../../js/services/integrations-internas/supercheckout';
import Errors from '../Util/errors';
import StripeConfig from '../GatewayConfig/StripeConfig';
import PaypalConfig from '../GatewayConfig/PaypalConfig';
import PagseguroConfig from '../GatewayConfig/PagseguroConfig';
import MercadopagoConfig from '../GatewayConfig/MercadopagoConfig';
import RazorpayConfig from '../GatewayConfig/RazorpayConfig';

export default {
  name: 'PricingPaymentOptions',
  props: ['value', 'isRecurrent', 'currency', 'info', 'auth'],
  components: {StripeConfig, PaypalConfig, PagseguroConfig, MercadopagoConfig, RazorpayConfig},

  data() {
    return {
      working: false,
      editing: false,
      hashWebhook: '',
      gateways: [],
      allowedGateways: ['stripe', 'paypal', 'pagseguro', 'mercadopago', 'razorpay'],

      userPaymentOptions: [],
      editingPaymentConfig: false,
      payment: {
        type: null
      },
      e: new Errors([])
    };
  },

  watch: {
    isRecurrent(isRecurrent, old) {
      if (typeof isRecurrent === 'undefined' || isRecurrent === old) return;

      this.setup();
    },

    currency(currency, old) {
      if (!currency || currency === old) return;

      this.setup();
    },

    userPaymentOptions: {
      handler(list) {
        this.$emit('input', list.filter(opt => opt.selected).map(opt => opt.hash));
        this.$emit('change', this);
      },
      deep: true
    },

    'payment.type': function() {
      this.e.clear();
      this.setup();
    },

    editingPaymentConfig(editing) {
      if (!editing)
        this.payment.type = null;

      this.$emit('editing', editing);
    }
  },

  computed: {
    paymentName() {
      let selected = this.gateways.find(g => g.slug === this.payment.type);

      if (selected) return selected.name;
    },

    builderallGateway() {
      //   let validation = false
      //   this.userPaymentOptions.filter(e => {
      //     if(e.gateway.slug === 'builderallgateway' && e.selected){
      //       validation = true
      //     }
      //   })
      //
      //   this.$emit('disableVat', validation)
      //   return validation
      return false;
    }
  },

  methods: {
    getSiteInfo,
    savePaymentConfig,
    removePaymentConfig,

    toggleSelected(option) {
      this.e.clearValidations();
      if (!option.enabled)
        option.selected = false;
      else
        option.selected = !option.selected;
    },

    close() {
      this.working = false;
      this.editing = false;
      this.editingPaymentConfig = false;
      // if(this.payment.type === 'vindi' && this.payment.vindi.hash){
      //   this.$refs.url.showModal();
      //   this.hashWebhook = this.payment.vindi.hash
      // }
      // else if(this.payment.type === 'razorpay' && this.payment.razorpay.hash){
      //   this.$refs.url.showModal();
      //   this.hashWebhook = this.payment.razorpay.hash
      // }
    },

    closeDialog() {
      this.$refs.url.close();
    },

    setup(cache = true) {
      return this.getSiteInfo(this.auth.token, cache).then(({data}) => {
        this.gateways = data.gateways.filter(g => {
          return this.allowedGateways.includes(g.slug);
        });
        this.gateways.forEach(g => {
          this.$set(this.payment, g.slug, {});
        });
        // FAMOSO IF ERICK
        // if(
        //     this.info.email !== 'leonardo.vasques@outlook.com' &&
        //     this.info.email !== 'admin@audiencereverse.es'  &&
        //     this.info.email !== 'simon@builderall.com'
        //   )
        //   this.gateways = data.gateways.filter(p => {
        //     return p.slug !== 'builderallgateway'
        //   })
        // else
        this.userPaymentOptions = data.userPaymentOptions
          .filter(o => this.allowedGateways.includes(o.gateway.slug))
          .map(o => {
            this.$set(o, 'enabled', true);
            this.$set(o, 'selected', false);

            if (this.isRecurrent && !o.gateway.enable_recurrent)
              o.enabled = false;

            if (!o.gateway.currencies.includes('*') && !o.gateway.currencies.includes(this.currency))
              o.enabled = false;

            if (o.enabled && this.value && this.value.length && this.value.includes(o.hash))
              o.selected = true;

            if (this.builderallGateway && o.gateway.slug !== 'builderallgateway') {
              o.enabled = false;
              o.selected = false;
            }

            return o;
          });
      });
    },

    removePaymentOption(option) {
      const actionRemove = (toast) => {
        this.removePaymentConfig(this.auth.token, option.hash).then(() => {
          this.$snotify.success(
            this.$t('dashboard.payment-remove-success'),
            this.$t('dashboard.payment-remove-title')
          );

          const optionIndex = this.userPaymentOptions.findIndex(opt => opt.hash === option.hash);
          this.userPaymentOptions.splice(optionIndex, 1);

          clearCache(this.auth.token, 'info');

          this.$snotify.remove(toast.id);
        }).catch(err => {
          this.$snotify.error(
            this.$t('dashboard.payment-remove-error'),
            this.$t('dashboard.payment-remove-title')
          );
        });
      };

      this.$snotify.warning(
        this.$t('dashboard.payment-remove-sure'),
        this.$t('dashboard.payment-remove-title'),
        {
          timeout: 0,
          backdrop: 0.5,
          closeOnClick: false,
          bodyMaxLength: 250,
          position: 'centerCenter',
          buttons: [
            {
              text: this.$t('dashboard.cancel'),
              action: toast => this.$snotify.remove(toast.id),
              bold: true
            },
            {
              text: this.$t('dashboard.confirm'),
              action: actionRemove,
              bold: false
            }
          ]
        }
      );
    },

    editPaymentOption(option) {
      this.payment.type = option.gateway.slug;
      this.$set(this.payment, this.payment.type, {
        name: option.name,
        hash: option.hash,
        ...option.config
      });
      this.editing = true;
      this.editingPaymentConfig = true;
    },

    toggleNewPaymentOption() {
      this.payment.type = null;
      this.editingPaymentConfig = !this.editingPaymentConfig;
    },

    savePayment() {
      this.working = true;
      this.savePaymentConfig(this.auth.token, this.payment).then(r => {
        this.$set(this.payment, this.payment.type, {});
        clearCache(this.auth.token, 'info');
        this.close();
      }).catch(err => {
        console.error(err);
        if (err.response.data.errors)
          this.e.record(err.response.data.errors);
        else
          this.e.add('keys', err.response.data.message);

        let firstError = document.querySelector(`[name='${this.e.first()}'`);
        if (firstError) firstError.focus();

        this.working = false;
      });
    }
  },

  mounted() {
    this.setup();
  },

  beforeDestroy() {
    window.removeEventListener('focus', this.savePayment, false);
  }
};
</script>

<style type="text/scss" scoped>
.has-error .payment-option {
  /*@apply border text-red-500 border-red-500;*/
}

.has-error .add-payment-button {
  /*@apply border text-red-500 border-red-500;*/
}

.rotate-45 {
  transform : rotate(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Checkout/Form/PricingPaymentOptions.vue